<template>
  <span class="iconfont" :class="iconName"></span>
</template>

<script>
// 图标
export default {
  name: 'iconfont',
  props: {
    name: String
  },
  computed: {
    iconName() {
      return 'icon' + this.name
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
